import { render, staticRenderFns } from "./LearnerRemarks.vue?vue&type=template&id=6f58e635&scoped=true&"
import script from "./LearnerRemarks.vue?vue&type=script&lang=js&"
export * from "./LearnerRemarks.vue?vue&type=script&lang=js&"
import style0 from "./LearnerRemarks.vue?vue&type=style&index=0&id=6f58e635&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f58e635",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VIcon,VSnackbar,VTab,VTabItem,VTabs,VTabsItems})
